import React, { useState, useEffect, useRef } from "react";
import FilterableProducts from "../../components/search/FilterableProducts";
import { useRequest } from "../../hooks/useRequest";
import styled from "styled-components";
import Button from "../../components/common/Button";
import SlidingBanner from "../../components/common/SlidingBanner";
import TrendingProductsGrid from "../../components/common/TrendingProductsGrid";
import { Skeleton } from "@mui/material";
import { useAppContext } from "../../context/useAppContext";
import SEO from "../../components/seo/SEO";

const GroupBuyStyle = styled.div`
  padding: 60px 0;
  .blogs__banner {
    margin: 0 0 60px;
    height: 200px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .page__title {
      color: #fff;
      font-size: 32px;
      font-weight: 700;
      line-height: 51px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 82.5px;
      display: flex;
      flex-direction: column;
      align-items: baseline;
      row-gap: 10px;
    }
  }
`;

const GroupBuy = () => {
  const [fetchBrands] = useRequest();
  const { categoriesTree: contextCategories, categoriesLoading } = useAppContext();
  const [brandsData, setBrandsData] = useState([]);
  const brandsFetchedRef = useRef(false);

  useEffect(() => {
    const fetchData = async () => {
      if (!brandsFetchedRef.current) {
        brandsFetchedRef.current = true;
        const brandData = await fetchBrands({
          path: `/brand?limit=100&page=1`,
        });
        setBrandsData(brandData?.data?.docs);
      }
    };

    fetchData();
  }, []); // Remove brandsData dependency

  const [
    fetchSlidingBanner,
    { isLoading: isFetchingSlidingBanner, state: slidingBanners },
  ] = useRequest(`/groupbuyslider?limit=10&page=1`);

  useEffect(() => {
    fetchSlidingBanner();
  }, []);

  return (
    <GroupBuyStyle>
      <SEO
        title="Group Buy Building Materials - Bulk Construction Products | Instabuild"
        description="Join group buy deals on building materials and construction products. Save on bulk purchases of roofing, lumber, tools, insulation, and more. Limited time group buy offers."
        keywords="group buy building materials, bulk construction supplies, group buy deals, bulk purchase building products, group buy construction materials, discounted building supplies"
      />
      <div className="container">
        <SlidingBanner
          reqHeight={180}
          onlyBanner={true}
          bannerData={slidingBanners?.data?.docs}
          leftdistance={30}
          loading={isFetchingSlidingBanner || !slidingBanners?.data?.docs}
        />
        <div style={{ marginBottom: 50 }}></div>
        {/* {categoriesLoading ? (
          <Skeleton variant="rectangular" width={"100%"} height={400} style={{ marginBottom: "50px" }} />
        ) : ( */}
          <FilterableProducts
              categoriesData={contextCategories}
            brandsData={brandsData}
            type="groupby"
            title="Group Buy Products"
          />
        {/* )} */}
      </div>
      <div className="container">
        <TrendingProductsGrid heading={"Top Selling Group Buy Products"} api={"/product/top-selling"} />
      </div>
    </GroupBuyStyle>
  );
};

export default GroupBuy;